import React, { ComponentPropsWithoutRef, ReactNode } from 'react';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

export interface TeamMemberData {
  id: string;
  fullName: string;
  position: string;
  about?: ReactNode;
  avatar?: string;
  width?: number;
  height?: number;
}

interface TeamMemberCardProps extends ComponentPropsWithoutRef<'div'> {
  teamMember: TeamMemberData;
  contentCentered?: boolean;
  photoIsInBlackFrame?: boolean;
}

export const TeamMemberCard = ({
  teamMember,
  className,
  contentCentered,
  photoIsInBlackFrame,
  ...props
}: TeamMemberCardProps) => {
  return (
    <div className={classNames('flex gap-8 items-center', className)} {...props}>
      <ImageProxy
        quality={100}
        width={teamMember.width}
        height={teamMember.height}
        alt={`${teamMember.fullName}'s avatar`}
        className="size-[6.5rem] flex-shrink-0 rounded-full bg-primary-50"
        src={teamMember.avatar}
        style={
          photoIsInBlackFrame
            ? {
                width: '96px',
                height: '96px',
                padding: '4px',
                borderRadius: '50%',
                background: '#080604',
                objectFit: 'cover',
              }
            : {}
        }
      />
      <div
        className={classNames({
          'flex flex-col justify-center h-full': contentCentered,
        })}
      >
        <p className="font-semibold">{teamMember.fullName}</p>
        <p className="font-medium text-neutral-500">{teamMember.position}</p>
        <div className="font-medium">{teamMember.about}</div>
      </div>
    </div>
  );
};

export default TeamMemberCard;
